export type Drama = {
  id: string;
  title: string;
  tag: string;
  updateTo: string;
  status: '更新中' | '已完结' | '今晚大结局';
  genre: string;
  ep: string;
  tonight: boolean;
  heat: string;
  desc: string;
  img: string;
};

export const tonightDramas: Drama[] = [
  {
    id: 't1',
    title: '暗河长明',
    tag: '悬疑犯罪',
    updateTo: '更新至第 28 集',
    status: '今晚大结局',
    genre: '悬疑',
    ep: '第28集 · 大结局',
    tonight: true,
    heat: '2280万',
    desc: '刑警林岸在追查连环案时，发现所有线索都指向二十年前的一桩旧案。真相与谎言的夹缝中，每个人都在扮演另一副面孔。',
    img: 'https://readdy.ai/api/search-image?query=moody%20neo-noir%20crime%20drama%20poster%20of%20a%20lone%20detective%20standing%20in%20a%20rainy%20night%20alley%20with%20neon%20signs%2C%20dark%20teal%20and%20amber%20lighting%2C%20cinematic%2C%20film%20grain%2C%20mysterious%20atmosphere%2C%20high%20contrast%2C%20editorial%20quality&width=600&height=820&seq=drama-anhe-01&orientation=portrait',
  },
  {
    id: 't2',
    title: '半夏有晴天',
    tag: '都市情感',
    updateTo: '更新至第 22 集',
    status: '更新中',
    genre: '都市',
    ep: '第22集',
    tonight: true,
    heat: '1930万',
    desc: '心怀咖啡师梦想的夏夏在旧城街角接手一家濒临倒闭的小店，她与固执的邻居主厨从针锋相对到并肩同行，治愈这座快节奏的城市。',
    img: 'https://readdy.ai/api/search-image?query=warm%20romantic%20urban%20drama%20poster%20with%20a%20young%20woman%20holding%20a%20coffee%20cup%20beside%20a%20sunny%20cafe%20window%2C%20golden%20hour%20light%2C%20soft%20cream%20and%20coral%20tones%2C%20cozy%20cinematic%2C%20editorial%20photography&width=600&height=820&seq=drama-banxia-02&orientation=portrait',
  },
  {
    id: 't3',
    title: '长安十二时辰·续',
    tag: '古装权谋',
    updateTo: '更新至第 34 集',
    status: '更新中',
    genre: '古装',
    ep: '第34集',
    tonight: true,
    heat: '2650万',
    desc: '上元灯会前夜，长安城暗流涌动。靖安司新锐与江湖孤客在十二时辰的倒计时里，揭开一场足以倾覆都城的惊天棋局。',
    img: 'https://readdy.ai/api/search-image?query=majestic%20ancient%20chinese%20dynasty%20drama%20poster%20with%20a%20warrior%20in%20armor%20before%20a%20grand%20palace%20under%20festival%20lanterns%2C%20rich%20crimson%20gold%20and%20teal%20tones%2C%20epic%20cinematic%2C%20editorial%20drama%20art&width=600&height=820&seq=drama-changan-03&orientation=portrait',
  },
  {
    id: 't4',
    title: '逆光而来',
    tag: '青春成长',
    updateTo: '更新至第 16 集',
    status: '更新中',
    genre: '青春',
    ep: '第16集',
    tonight: true,
    heat: '1420万',
    desc: '一群海边小镇的少年少女，在毕业前的最后一年里追逐各自的微光。友情、梦想与错过，都在逆光里慢慢显影。',
    img: 'https://readdy.ai/api/search-image?query=bright%20youth%20coming%20of%20age%20drama%20poster%20of%20teenagers%20on%20a%20seaside%20pier%20at%20sunset%2C%20backlit%20golden%20glow%2C%20fresh%20blue%20and%20warm%20orange%2C%20nostalgic%20cinematic%2C%20editorial%20quality&width=600&height=820&seq=drama-niguang-04&orientation=portrait',
  },
  {
    id: 't5',
    title: '我家那口锅',
    tag: '家庭喜剧',
    updateTo: '更新至第 12 集',
    status: '更新中',
    genre: '家庭',
    ep: '第12集',
    tonight: true,
    heat: '1680万',
    desc: '老字号面馆的掌勺爷爷突然宣布「退休」，三个各怀心事的子女被迫回店接班。一碗热汤面，熬出三代人的和解。',
    img: 'https://readdy.ai/api/search-image?query=heartwarming%20chinese%20family%20comedy%20drama%20poster%20of%20a%20grandfather%20and%20adult%20children%20around%20a%20steaming%20noodle%20table%20in%20a%20cozy%20old%20restaurant%2C%20warm%20amber%20kitchen%20light%2C%20inviting%20homespun%2C%20cinematic%2C%20editorial&width=600&height=820&seq=drama-guoguo-05&orientation=portrait',
  },
  {
    id: 't6',
    title: '白夜迷局',
    tag: '烧脑悬疑',
    updateTo: '更新至第 9 集',
    status: '更新中',
    genre: '悬疑',
    ep: '第9集',
    tonight: true,
    heat: '1210万',
    desc: '一家三口接连失踪，只在监控里留下重复七天的同一段影像。新来的剪辑师发现，这盘录像带似乎能「预告」命运。',
    img: 'https://readdy.ai/api/search-image?query=tense%20psychological%20mystery%20drama%20poster%20of%20an%20old%20camera%20and%20empty%20family%20living%20room%20at%20night%2C%20monochromatic%20blue%20grey%20with%20a%20single%20red%20light%2C%20unsettling%20cinematic%2C%20editorial&width=600&height=820&seq=drama-baiye-06&orientation=portrait',
  },
];

export const airingCalendar: { day: string; list: string[] }[] = [
  { day: '一', list: ['暗河长明', '半夏有晴天', '我家那口锅'] },
  { day: '二', list: ['长安十二时辰·续', '逆光而来'] },
  { day: '三', list: ['暗河长明', '白夜迷局', '晚风予你'] },
  { day: '四', list: ['半夏有晴天', '长安十二时辰·续'] },
  { day: '五', list: ['暗河长明', '我家那口锅', '山城旧事'] },
  { day: '六', list: ['逆光而来', '晚风予你', '白夜迷局'] },
  { day: '日', list: ['长安十二时辰·续', '半夏有晴天', '暗河长明'] },
];

export const genres = [
  { name: '悬疑罪案', count: 128, icon: 'ri-spy-line', img: 'https://readdy.ai/api/search-image?query=moody%20detective%20office%20at%20night%20with%20case%20files%20and%20evidence%20board%20pinned%20with%20red%20threads%2C%20noir%20dark%20amber%20lighting%2C%20cinematic%2C%20editorial&width=520&height=380&seq=genre-xuanyi-01&orientation=landscape' },
  { name: '都市情感', count: 214, icon: 'ri-heart-3-line', img: 'https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20dusk%20through%20a%20glass%20apartment%20window%20with%20warm%20lights%2C%20romantic%20urban%20cinematic%2C%20cream%20and%20coral%20tones%2C%20editorial&width=520&height=380&seq=genre-dushi-02&orientation=landscape' },
  { name: '古装权谋', count: 176, icon: 'ri-sword-line', img: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20courtyard%20with%20flowing%20robes%20and%20calligraphy%20scrolls%2C%20crimson%20gold%20and%20teal%2C%20epic%20cinematic%2C%20editorial&width=520&height=380&seq=genre-guzhuang-03&orientation=landscape' },
  { name: '家庭生活', count: 158, icon: 'ri-home-heart-line', img: 'https://readdy.ai/api/search-image?query=cozy%20warm%20family%20dining%20room%20with%20steaming%20dishes%20and%20faded%20photo%20frames%2C%20golden%20afternoon%20light%2C%20homespun%20cinematic%2C%20editorial&width=520&height=380&seq=genre-jiating-04&orientation=landscape' },
  { name: '青春校园', count: 97, icon: 'ri-sun-line', img: 'https://readdy.ai/api/search-image?query=bright%20school%20campus%20bicycle%20and%20green%20trees%20under%20sunlight%2C%20fresh%20spring%20vibes%2C%20nostalgic%20cinematic%2C%20editorial&width=520&height=380&seq=genre-qingchun-05&orientation=landscape' },
  { name: '年代大戏', count: 143, icon: 'ri-time-line', img: 'https://readdy.ai/api/search-image?query=retro%20chinese%20street%20from%20the%201980s%20with%20old%20shops%20and%20wrought%20iron%20balconies%2C%20sepia%20warm%20tones%2C%20cinematic%20nostalgia%2C%20editorial&width=520&height=380&seq=genre-qiandai-06&orientation=landscape' },
];

export const rankList: { rank: number; title: string; genre: string; trend: 'up' | 'down' | 'flat'; img: string; heat: string }[] = [
  { rank: 1, title: '长安十二时辰·续', genre: '古装权谋', trend: 'flat', heat: '2650万', img: 'https://readdy.ai/api/search-image?query=majestic%20ancient%20chinese%20drama%20cover%20with%20warrior%20armor%20and%20palace%20lanterns%2C%20crimson%20gold%2C%20cinematic%2C%20editorial&width=300&height=400&seq=rank-changan-01&orientation=portrait' },
  { rank: 2, title: '暗河长明', genre: '悬疑犯罪', trend: 'up', heat: '2280万', img: 'https://readdy.ai/api/search-image?query=noir%20detective%20drama%20cover%20lone%20figure%20rainy%20neon%20alley%2C%20dark%20teal%20amber%2C%20cinematic%2C%20editorial&width=300&height=400&seq=rank-anhe-02&orientation=portrait' },
  { rank: 3, title: '半夏有晴天', genre: '都市情感', trend: 'up', heat: '1930万', img: 'https://readdy.ai/api/search-image?query=warm%20urban%20romance%20drama%20cover%20coffee%20cup%20sunny%20cafe%2C%20cream%20coral%2C%20cinematic%2C%20editorial&width=300&height=400&seq=rank-banxia-03&orientation=portrait' },
  { rank: 4, title: '我家那口锅', genre: '家庭喜剧', trend: 'down', heat: '1680万', img: 'https://readdy.ai/api/search-image?query=cozy%20family%20comedy%20drama%20cover%20noodle%20table%20warm%20kitchen%2C%20amber%2C%20cinematic%2C%20editorial&width=300&height=400&seq=rank-guoguo-04&orientation=portrait' },
  { rank: 5, title: '晚风予你', genre: '甜宠', trend: 'up', heat: '1510万', img: 'https://readdy.ai/api/search-image?query=soft%20romance%20drama%20cover%20couple%20silhouette%20city%20night%20warm%20lights%2C%20gentle%20cream%20and%20rose%2C%20cinematic%2C%20editorial&width=300&height=400&seq=rank-wanfeng-05&orientation=portrait' },
  { rank: 6, title: '逆光而来', genre: '青春成长', trend: 'down', heat: '1420万', img: 'https://readdy.ai/api/search-image?query=youth%20seaside%20drama%20cover%20backlit%20sunset%20pier%2C%20golden%20blue%2C%20cinematic%2C%20editorial&width=300&height=400&seq=rank-niguang-06&orientation=portrait' },
];

export const news = [
  {
    tag: '剧情速递',
    date: '今晚 21:00',
    title: '《暗河长明》大结局前哨：最后一枚棋子在谁手里？',
    excerpt: '随着「河图计划」真凶逐渐浮出水面，今晚即将迎来大结局。观众发现，前 27 集埋下的每一条线，都在为这场收网做铺垫。',
    img: 'https://readdy.ai/api/search-image?query=crime%20board%20with%20red%20threads%20and%20photographs%20in%20a%20dim%20police%20office%2C%20noir%20amber%20lighting%2C%20cinematic%2C%20editorial&width=640&height=420&seq=news-anhe-01&orientation=landscape',
  },
  {
    tag: '吃瓜热议',
    date: '今晚 20:30',
    title: '「半夏CP」今晚窗台告白名场面，弹幕都疯了',
    excerpt: '夏夏与主厨的感情线迎来高光时刻，片方释出的预告片段在站内播放量已破百万，网友直呼「这口糖我先磕为敬」。',
    img: 'https://readdy.ai/api/search-image?query=young%20couple%20silhouette%20at%20a%20cafe%20window%20at%20golden%20hour%2C%20romantic%20warm%20light%2C%20cream%20coral%2C%20cinematic%2C%20editorial&width=640&height=420&seq=news-banxia-02&orientation=landscape',
  },
  {
    tag: '抢先看',
    date: '今晚 19:50',
    title: '《长安十二时辰·续》今夜更新预告：靖安司夜闯云阁',
    excerpt: '新一集将首次揭晓云阁的真正主人。片花中一闪而过的鎏金令牌，让不少考据党连夜翻起了人物谱系。',
    img: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20night%20market%20with%20lanterns%20and%20guards%20moving%20through%2C%20crimson%20gold%20teal%2C%20epic%20cinematic%2C%20editorial&width=640&height=420&seq=news-changan-03&orientation=landscape',
  },
  {
    tag: '剧集安利',
    date: '昨天 22:10',
    title: '剧荒救星：本周 6 部「冷门高分」连续剧清单',
    excerpt: '不想跟着大热剧走？我们整理了一份本周口碑与热度双在线的小众好剧，覆盖悬疑、古装、家庭与青春四个方向。',
    img: 'https://readdy.ai/api/search-image?query=stack%20of%20books%20and%20tea%20cup%20on%20a%20cozy%20desk%20with%20warm%20lamplight%20and%20film%20posters%20behind%2C%20cozy%20editorial%2C%20cinematic&width=640&height=420&seq=news-anli-04&orientation=landscape',
  },
];

export const testimonials = [
  {
    name: '追剧小能手·阿柚',
    role: '悬疑剧重度用户',
    text: '每天最怕的就是漏更，自从关注了这里，更新日历比闹钟还准时，我甚至能提前规划好「今晚看哪部」。',
    score: 5,
  },
  {
    name: '晚睡的猫',
    role: '古装剧考据党',
    text: '这里的剧情解读不是标题党，是真的把伏笔一条条挖出来讲清楚，追更之余还能补充好多背景知识。',
    score: 5,
  },
  {
    name: '周末剧场',
    role: '家庭剧爱好者',
    text: '分类很细、榜单更新也快，剧荒的时候过来翻一翻，总能找到想看的。界面干净，看得很舒服。',
    score: 4,
  },
];

export const faqs = [
  {
    q: '「55吃瓜」是追更提醒工具吗？多久更新一次？',
    a: '是的，站内提供连续剧的播出日历、今晚更新动态与剧情速递。常规剧集的更新信息会在开播前整理、播出当晚集中刷新，周末的追更日历则提前一天更新。',
  },
  {
    q: '如何第一时间收到某部剧的更新提醒？',
    a: '你可以在本页底部填写常用邮箱完成订阅，我们会以「今日更新清单」的形式推送你关注的剧集动态。订阅与退订都很简单，邮件中一键即可完成。',
  },
  {
    q: '剧情速递和抢先看会剧透吗？',
    a: '会明确标注。所有「剧情速递」均以不破坏观剧体验为原则，只做不影响关键悬念的导读；「抢先看」内容则会在标题前用标签单独提示，你可自行选择是否阅读。',
  },
  {
    q: '热播榜的数据是怎么来的？',
    a: '榜单综合了站内讨论热度、搜索量与实际播出热度综合计算，分为总榜与周榜。榜单每日更新一次，供你快速判断最近的「大家都在追什么」。',
  },
  {
    q: '站内提供剧集在线观看吗？',
    a: '本站是追更与导览资讯站，不提供、也不转载任何影视正片资源。观看请前往各剧集的正规授权平台。',
  },
  {
    q: '剧荒想找同类型剧，有推荐入口吗？',
    a: '当然。首页「剧集分类」覆盖悬疑罪案、都市情感、古装权谋、家庭生活、青春校园、年代大戏六大类，每类下都整理了热度与口碑靠前的剧集清单。',
  },
];